import { CHANGE_SAVE_STATE } from '../constants'

export default (index, saveState) => ({
    type: CHANGE_SAVE_STATE,
    index,
    saveState
})
